import { api } from './api';

export interface HearingBrief {
  hearing: {
    id: string;
    date: string;
    time: string;
    hoursUntil: number;
    court: string;
    courtroom: string | null;
    judge: string | null;
    type: string;
    durationLabel: string;
    status: string;
    isVirtual: boolean;
    videoLink: string | null;
    notes: string | null;
    outcome: string | null;
  };
  matter: {
    id: string;
    caseNumber: string | null;
    caseName: string;
    status: string;
    practiceArea: string | null;
    description: string | null;
    leadBarristerName: string | null;
    juniorBarristerName: string | null;
    instructingSolicitorName: string | null;
    layClientName: string | null;
  };
  preparation: {
    sinceLastVisit: {
      previousVisitAt: string;
      newDocuments: number;
      newCorrespondence: number;
      newActivity: number;
    } | null;
    recentDocuments: Array<{
      id: string;
      name: string;
      category: string;
      uploadedAt: string;
      uploadedByName: string;
      isNew: boolean;
    }>;
    recentActivity: Array<{
      description: string;
      actorName: string;
      timestamp: string;
      isNew: boolean;
    }>;
    recentCorrespondence: Array<{
      id: string;
      source: 'thread' | 'email';
      subject: string;
      preview: string | null;
      counterpart: string | null;
      channel: string;
      at: string;
      unread: boolean;
      isNew: boolean;
    }>;
    previousHearing: {
      date: string;
      type: string;
      outcome: string | null;
      status: string;
    } | null;
    allCaseHearings: Array<{
      id: string;
      date: string;
      type: string;
      status: string;
      outcome: string | null;
      isCurrent: boolean;
    }>;
    estimatedReviewMinutes: number;
  };
  intelligence: {
    preparationStatus: 'ready' | 'review_required' | 'action_needed';
    documentsAddedCount: number;
    activityCount: number;
    isUpcoming: boolean;
    isPast: boolean;
    requiresOutcome: boolean;
  };
}

export async function fetchHearingBrief(hearingId: string): Promise<HearingBrief> {
  const res = await api.get(`/hearings/${hearingId}/brief`);
  return (res.data as any).data as HearingBrief;
}
